import axiosInstance from '../../../config/axiosInstance';
const  ContactDocumentService = {
    async GetAllContactDocuments(redirectCallback,ClientContactID) {
        try {     
           const response = await axiosInstance.get(`/Customer/GetContactDocument?ClientContactID=${ClientContactID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
   async DeleteContactDocument(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Customer/DeleteContactDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default ContactDocumentService;